import api from '@/api/index.js'

const account_emv_clearing = {
  state: {
    loading: false,
    updating: false,
    data: null,
    // createdMoneyClaimId: null,
    // updatedMoneyClaim: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_EMV_CLEARING_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_EMV_CLEARING_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_EMV_CLEARING: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_EMV_CLEARING_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadAccountEmvClearing({commit}, req) {
      commit('SET_ACCOUNT_EMV_CLEARING_LOADING', true)
      commit('SET_ACCOUNT_EMV_CLEARING_ERROR', null)
      return api.get(`accounts/${req.accountID}/emv-clearings/${req.resourceId}`)
        .then((response) => {
          commit('SET_ACCOUNT_EMV_CLEARING', response)
          commit('SET_ACCOUNT_EMV_CLEARING_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_EMV_CLEARING_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default account_emv_clearing
